import React from 'react';

import { UserCreatePasswordChangeRequestModalContent } from 'src/components/account';
import { Modal } from 'src/components/common';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export const UserCreatePasswordChangeRequestModal: React.FC = () => {
  const { closeModal, isOpen, switchClosability } = useModal<{
    emailChanged: boolean;
    emailConfirmed: boolean;
  }>(ModalId.UserCreatePasswordChangeRequestModal);

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
      title="We will send you a password reset link"
      maxWidth={460}
      headerPadding="20px 32px 0 32px"
    >
      <UserCreatePasswordChangeRequestModalContent
        onCloseModal={onCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
